import React, { useState, useEffect } from 'react';
import ApiClient from '../../../methods/api/apiClient';
import loader from '../../../methods/loader';
import './style.scss';
import Html from './Html';
import { useNavigate, useParams } from 'react-router-dom';
import formModel from '../../../models/form.model';
import { useDispatch, useSelector } from 'react-redux';
import { login_success } from '../../../Pages/actions/user';

const EditProfile = () => {
  const user = useSelector((state:any) => state.user);
  const { id: routeId } = useParams<{ id?: string }>();
  const targetId = routeId || user._id;
  const isOtherUser = !!routeId && routeId !== user._id;
  const dispatch=useDispatch()
  const [data, setData] = useState('');
  const [form, setForm]:any = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [images, setImages]:any = useState({ image: '' });
  const history=useNavigate()
  const [submitted, setSubmitted] = useState(false)

  const gallaryData = () => {
    loader(true)
    setIsLoading(true)
    ApiClient.get(`api/user/detail`,{id:targetId}).then(res => {
      if (res.success) {
        let value = res.data
        let payload:any = {
          id: targetId,
          email: value.email || '',
          mobileNo: (() => {
            const raw = String(value.mobileNo || '').replace(/\D/g, '');
            if (!raw) return '';
            return raw.startsWith('1') ? raw : `1${raw}`;
          })(),
          firstName: value.firstName || '',
          lastName: value.lastName || '',
          multiAddress: value.multiAddress || [],
          profession: value.profession || '',
          company: value.company || '',
          companyUrl: value.companyUrl || '',
          address: value.address || '',
          address2: value.address2 || '',
          state: value.state || '',
          postal_code: value.postal_code || '',
          city: value.city || '',
          timezone: value.timezone || Intl.DateTimeFormat().resolvedOptions().timeZone || 'America/Los_Angeles',
          secondaryEmail: value.secondaryEmail || '',
          adminComment: value.adminComment || '',
          linkedInUrl: value.linkedInUrl || '',
          certification: value.certification || '',
          skills: value.skills || [],
          networkingGroup: value.networkingGroup || '',
          category: value.category?._id || value.category || null,
          subCategory: value.subCategory?._id || value.subCategory || null,
          subSubCategory: value.subSubCategory?._id || value.subSubCategory || null,
          aboutUs: value.aboutUs || '',
          country: value.country || 'usa'
        }
        setForm(payload)
        let img = images
        Object.keys(images).map(itm => {
          img[itm] = value[itm]
        })
        setImages({ ...img })
        setData(value)
      }
      loader(false)
      setIsLoading(false)
    })
  };

  const getError = (key:any) => {
    return formModel.getError('profileForm',key)
  }

  const handleSubmit = (e:any) => {
    e.preventDefault();
    setSubmitted(true)
    // let invalid = formModel.getFormError('profileForm')
    // if (invalid) return

    let value = { ...form,
      id: targetId,
      addedBy: user._id,
      // verifiedGroupLeader:'approved',
      ...images
     }
   Object.keys(value).map(itm=>{
    if(!value[itm]) value[itm]=null
   })

    loader(true)
    ApiClient.put('api/user', value).then(res => {
      if (res.success) {
        if (!isOtherUser) {
          let uUser = { ...user, ...value }
          dispatch(login_success(uUser))
          history("/profile")
        } else {
          history(`/user-profile/${targetId}`, { replace: true })
        }
      }
      loader(false)
    })
  };

  const uploadImage = (e:any) => {
    setForm({ ...form, baseImg: e.target.value })
    let files = e.target.files
    let originalFile = files.item(0)
    const safeName = originalFile.name.replace(/[^a-zA-Z0-9_\-. ]/g, '')
    const file = new File([originalFile], safeName, { type: originalFile.type })
    loader(true)
    ApiClient.postFormData('api/upload/image?modelName=users', { file: file, modelName: 'users' }).then(res => {
      if (res.fileName) {
        let image = res.fileName
        setForm({ ...form, image: image, baseImg: '' })
      } else {
        setForm({ ...form, baseImg: '' })
      }
      loader(false)
    })
  }

 
  const imageResult = (e:any, key:any) => {
    images[key] = e.value
    setImages(images)

}


  useEffect(
    () => {
      if (user.loggedIn) {
        gallaryData();
      }
    },[]);

    if (isLoading || !form) {
      return (
        <div className="text-center py-8">
          <img src="/assets/img/loader.gif" className="pageLoader" alt="Loading..." />
        </div>
      );
    }
  
    return (
      <>
       <Html
     handleSubmit={handleSubmit}
     setForm={setForm}
     imageResult={imageResult}
     images={images}
     form={form}
     uploadImage={uploadImage}
     getError={getError}
     submitted={submitted}
     />
    </>
  );
};

export default EditProfile;
